import script from "./VueloCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VueloCard.vue?vue&type=script&setup=true&lang=js"

import "./VueloCard.vue?vue&type=style&index=0&id=299647fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299647fb"]])

export default __exports__